import React from 'react';

const Thumbnail = () => (
  <div className="w-full h-20 rounded-lg bg-zinc-100 dark:bg-zinc-800 p-2 flex items-center justify-center gap-1.5">
    {[1, 2, 3].map(i => (
      <div key={i} className={`w-8 ${i === 2 ? 'h-14' : 'h-12'} bg-zinc-200 dark:bg-zinc-700 rounded p-1 flex flex-col items-center gap-0.5`}>
        <div className="w-4 h-1 bg-zinc-300 dark:bg-zinc-600 rounded" />
        <div className="w-3 h-1.5 bg-primary/40 rounded" />
      </div>
    ))}
  </div>
);

export default Thumbnail;
